import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from "../../services/application.service";

@Component({
  selector: 'app-modal-attachment-update',
  templateUrl: './modal-attachment-update.component.html',
  styles: []
})
export class ModalAttachmentUpdateComponent extends ExcTranslation implements OnInit {

  @Input() data: { dokID: string } = {dokID: ''};

  userType: number | any;

  uiSelectDocumentTypeIndex = this.enumSvc.getEnumerationList('DokTyp').findIndex(e => e.enmDefault);

  dokEigenschaftTypList: any[] = [];

  dokEigenschaftHelper: any = {};

  uiModel = {
    dokTrackingPortalShare: false,
    dokBeschreibung: '',
    dok_enmIdent_DokTyp: 1,
    dokName: '',
    DokEigenschaft:[] as any[]
  };

  constructor(public modalService: ExgModalService,
              private excRestService: ExcRestService,
              public appSvc: ApplicationService,
              public excSec: ExcSecurityService,
              public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    this.getDocumentInfo();
  }

  createDokEigenschaft(): void{
    this.uiModel.DokEigenschaft = [];
    for(const key in this.dokEigenschaftHelper) {
      this.uiModel.DokEigenschaft.push({dokEigID: key as unknown as number, dokEigValue: this.dokEigenschaftHelper[key]})
    }
  }

  getDocumentInfo(): void {
    this.excRestService.get(this.excRestService.computeUrl('DocumentR_Summary', {dokID: this.data.dokID, IncludeBinary: false})).subscribe((response: any) => {
      if (response) {
        this.uiModel.dokTrackingPortalShare = response.data.Document.dokTrackingPortalShare;
        this.uiModel.dokBeschreibung = response.data.Document.dokBeschreibung;
        this.uiModel.dokName = response.data.Document.dokName;
        this.uiModel.dok_enmIdent_DokTyp = response.data.Document.dok_enmIdent_DokTyp;
        this.dokEigenschaftTypList = this.enumSvc.getDokEigenschaftTypList(this.uiModel.dok_enmIdent_DokTyp);
        this.uiSelectDocumentTypeIndex = this.enumSvc.getEnumerationList('DokTyp').findIndex(e => e.enmIdent === this.uiModel.dok_enmIdent_DokTyp);
        for(let prop of response.data.DocumentProperties){
          this.dokEigenschaftHelper[prop.dev_detIdent] = prop.devValue;
        }
      }
    });
  }

  setDocumentType(e: any): void {
    this.uiSelectDocumentTypeIndex = e;
    this.uiModel.dok_enmIdent_DokTyp = this.enumSvc.getEnumerationList('DokTyp')[e]['enmIdent'];
    this.dokEigenschaftTypList = this.enumSvc.getDokEigenschaftTypList(this.uiModel.dok_enmIdent_DokTyp);
    this.dokEigenschaftHelper = {};
  }

  close(): void {
    this.modalService.close();
  }

  save(): void {
    this.createDokEigenschaft();
    this.modalService.action(this.uiModel);
  }

}
